import { Link } from '@tanstack/react-router'
import type { useNotFoundFloraModel } from '@/components/shared/not-found-flora/not-found-flora.model'

type NotFoundFloraViewProps = ReturnType<typeof useNotFoundFloraModel>

export function NotFoundFloraView({
  headline,
  message,
  catalogHref,
  catalogLabel,
}: NotFoundFloraViewProps) {
  return (
    <div className="fz-not-found">
      <svg
        className="fz-not-found__petal"
        viewBox="0 0 120 220"
        aria-hidden="true"
        focusable="false"
      >
        <path
          className="fz-not-found__petal-outline"
          d="M60 8 C 22 46, 10 108, 60 212 C 110 108, 98 46, 60 8 Z"
        />
        <path
          className="fz-not-found__petal-vein"
          d="M60 24 C 66 84, 66 148, 60 200"
        />
        <path
          className="fz-not-found__petal-vein"
          d="M60 56 C 44 82, 40 118, 58 158"
        />
        <path
          className="fz-not-found__petal-vein"
          d="M60 56 C 76 82, 80 118, 62 158"
        />
      </svg>
      <h1 className="fz-not-found__headline">{headline}</h1>
      <p className="fz-not-found__message">{message}</p>
      <Link to={catalogHref} className="fz-not-found__link">
        {catalogLabel}
      </Link>
    </div>
  )
}
